import { Flex, Text } from "@chakra-ui/react";
import { YIELD_TEXT_STRINGS } from "@components/VaultYield/contants";
import usePrices from "@hooks/usePrices";
import React from "react";
import { numberToCurrency } from "utils";
import { useAccount } from "wagmi";

const TEXT_STRINGS = YIELD_TEXT_STRINGS.SECTIONS.PORTFOLIO.HOLDINGS;

type HoldingsProps = {
  balance: string;
  balanceEth?: string | number;
  symbol: string;
};

const VaultHoldings = ({ balance, balanceEth, symbol }: HoldingsProps) => {
  const { isConnected } = useAccount();
  const { assets, isLoading: exchangePricesLoading } = usePrices();

  return (
    <Flex direction={"column"} p="20px" gap="20px">
      {!isConnected && (
        <Text fontSize="12px" lineHeight="14.4px" fontWeight="400" mb="12px">
          {TEXT_STRINGS.walletConnect}
        </Text>
      )}

      <Flex direction={"column"}>
        <Text
          fontSize="32px"
          fontWeight="500"
          lineHeight={"38.4px"}
          letterSpacing={"-1%"}
        >
          {balance} {symbol}
        </Text>
        {balanceEth &&
          balanceEth != "-" &&
          !exchangePricesLoading &&
          assets?.ETH?.usd && (
            <Text fontSize="20px" lineHeight="120%" fontWeight="300" mt="2">
              {/* TODO:: find USD Value */}
              {/* $ {numberToCurrency(xTokenYieldVaultBalance.toString())} */}
              {`${numberToCurrency(
                balanceEth.toString()
              )} ETH ($${numberToCurrency(
                (Number(balanceEth) * assets?.ETH?.usd).toFixed(4)
              )})`}
            </Text>
          )}
      </Flex>
      {/* 
      <Flex
        bgColor={"#ECDAC5"}
        p="12px"
        borderRadius={"12px"}
        justifyContent={"space-between"}
      >
        <Flex direction={"column"} gap="16px">
          <Text fontSize="12px" lineHeight="14.4px" fontWeight="600">
            {TEXT_STRINGS.nexusMutual.title}
          </Text>
          <Button width={"136px"} gap="8px">
            <Text fontSize="12px" lineHeight="14.4px" fontWeight="600">
              {TEXT_STRINGS.nexusMutual.CTA}
            </Text>
            <BaseImage
              src="/assets/external-link.svg"
              width={15}
              height={15}
              alt="nexus"
            />
          </Button>
        </Flex>
        <BaseImage
          src={TEXT_STRINGS.nexusMutual.imgSrc}
          alt=""
          width={"60"}
          height={"60"}
        />
      </Flex> */}
    </Flex>
  );
};

export default VaultHoldings;
